import { Button } from '@mui/material';
import * as React from 'react'
import Loader from "react-loader-spinner";
import ActionButton from '../general/ActionButton';
import { GDataContext } from './GDataContext';


type Props = {
  children
}

const GDataLoadingGuard: React.FC = ({ children }: Props) => {
  const baseGraphContext = React.useContext(GDataContext);

  const isLoading = !baseGraphContext.dataset;
  const hasError = baseGraphContext.hasError;

  return (
    <div>
      {hasError &&
        <div className="flex flex-col items-center my-20">
          <p className="font-medium mb-2">Network error</p>
          <p>
            <ActionButton onClick={() => baseGraphContext.retry()} disableElevation={true} color="primary" variant="contained">
              Retry
              </ActionButton>
          </p>
        </div>
      }
      {!hasError && isLoading &&
        <div className="flex flex-col items-center my-20">
          <Loader color="#27A3A4" type="ThreeDots"></Loader>
          <p className="">Loading the Lightning network...</p>
          <p className="text-xs text-gray-700">This can take several seconds. Just hang on tight.</p>
        </div>
      }
      {!isLoading && children}
    </div>
  );
}

export default GDataLoadingGuard;

